import { render, staticRenderFns } from "./AvatarBuilder.vue?vue&type=template&id=9c4d38ee&scoped=true&"
import script from "./AvatarBuilder.vue?vue&type=script&lang=js&"
export * from "./AvatarBuilder.vue?vue&type=script&lang=js&"
import style0 from "./AvatarBuilder.vue?vue&type=style&index=0&id=9c4d38ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4d38ee",
  null
  
)

export default component.exports